import { useMutation, useQuery, useQueryClient } from "react-query";
import React, { Fragment, useState, useCallback, useEffect } from "react";
import PolicyFeeTable from "./PolicyFeeTable";
import { getStates } from "../../actions/Utilities/Common";
import { getFeeLevel } from "../../actions/Utilities/FeeLevel";
import {
  getFees,
  deletePolicyFees,
  searchFees,
  exportPolicyFees,
} from "../../actions/Utilities/Fees";
import { toast } from "../../components/toastNotification";
import AddPolicyFeeForm from "./AddPolicyFeeForm";
import AddButton from "../../components/AddButton";
import EditButton from "../../components/EditButton";
import DownloadButton from "../../components/DownloadButton";
import ConfirmBoxModal from "../../components/ConfirmBoxModal";
import { CreditCardIcon, FunnelIcon } from "@heroicons/react/24/solid";
import TableFilters from "./TableFilters";
import { getFeeType } from "../../actions/Utilities/Policy";
import { notificationFilter } from "../../actions/Utilities/NotificationFilter";
import { useGetPolicyTerms } from "./hooks/useGetPolicyTerms";
import { permissionsSelector } from "../Login/selectors/permissionSelector";
import { useRecoilValue } from "recoil";
import { PERMISSIONS } from "../PermissionsConstants";
import { notificationFilterById } from "../../actions/Utilities/NotificationFilter";
import { useHistory, useLocation } from "react-router-dom";
import MassUploadButton from "../../components/MassUploadButton";
import { ArrowUpCircleIcon } from "@heroicons/react/24/solid";
import { useGetCarrierNameList } from "modules/CarrierAgreementMgmt/Carrier/hooks/useGetCarrierNameList";
import MassUpload from "./MassUpload";

const PolicyFee = () => {
  const [policyFeeData, setPolicyFeeData] = useState([]);
  const [searchInputsData, setSearchInputsData] = useState([]);
  const [feeLevelOptions, setFeeLevelOptions] = useState([]);
  const [stateOptions, setStates] = useState([]);
  const [addPolicyFee, setAddPolicyFee] = useState(false);
  const [filter, setFilter] = useState(false);
  const [filterPolicyFeeData, setFilterPolicyFeeData] = useState([]);
  const [resetStatus, setResetStatus] = useState(false);
  const [filterStatus, setFilterStatus] = useState(false);
  const [isBulkSelected, setIsBulkSelected] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [clearSelectedRows, setClearSelectedRows] = useState(false);
  const [feeTypeData, setFeeTypeData] = useState([]);
  const [policyTermOptions, setPolicyTerm] = useState([]);
  const [policyFeeFilteredData, setPolicyFeeFilteredData] = useState([]);
  const [massUploadModal, setMassUploadModal] = useState(false);

  const userPermissions = useRecoilValue(permissionsSelector);
  const addPermission = PERMISSIONS.permission_policyfee_add;
  const downloadPremission = PERMISSIONS.permission_policyfee_download;
  const queryClient = useQueryClient();
  let location = useLocation();
  const history = useHistory();
  let recordIdFromRecent = "";
  if (location.state != null) {
    recordIdFromRecent = location.state;
  }

  useEffect(() => {
    if (recordIdFromRecent != "") {
      try {
        notificationFilterById(
          recordIdFromRecent.recordId,
          recordIdFromRecent.moduleName,
          recordIdFromRecent.subModuleName
        ).then((result) => {
          setPolicyFeeFilteredData(result);
          history.replace();
        });
      } catch (error) {
        //console.log("error "+error);
      }
    } else {
      localStorage.removeItem("NotifFilter");
      localStorage.removeItem("ModuleFilter");
    }
  }, []);

  const searchMutation = useMutation(
    (searchInputsData) => searchFees({ ...searchInputsData }),
    {
      refetchOnWindowFocus: false,
      onSuccess: (res) => {
        queryClient.invalidateQueries("Fees");
        setFilterPolicyFeeData(
          res.map((responseData) => {
            return {
              ...responseData,
            };
          })
        );
      },
      onError: (error) => {},
    }
  );
  const handleExportButton = () => {
    try {
      var myCurrentDate = new Date();
      var date =
        myCurrentDate.getFullYear() +
        "-" +
        (myCurrentDate.getMonth() + 1) +
        "-" +
        myCurrentDate.getDate() +
        " " +
        myCurrentDate.getHours() +
        ":" +
        myCurrentDate.getMinutes() +
        ":" +
        myCurrentDate.getSeconds();
      const ids = filterStatus
        ? filterPolicyFeeData.map((row) => row.commissionablePremiumId)
        : policyFeeData.map((row) => row.commissionablePremiumId);
      exportPolicyFees(ids, filterStatus).then((content) => {
        var url = window.URL.createObjectURL(content.data);
        let tempLink = document.createElement("a");
        tempLink.href = url;
        tempLink.setAttribute("download", "Policy Fees " + date + ".xlsx");
        tempLink.click();
        toast.fire(
          "Success",
          "Policy Fees were Exported Successfully",
          "success"
        );
      });
    } catch (error) {
      toast.fire(
        "Failed to Export",
        "Server Error: Cannot Policy Fees Codes due to: " + error,
        "error"
      );
    }
  };

  const { policyTerms } = useGetPolicyTerms(true);
  useEffect(() => {
    setPolicyTerm(policyTerms);
  });

  // useEffect(() => {
  //   var params = JSON.parse(localStorage.getItem("ModuleFilter"));
  //   if (
  //     localStorage.getItem("NotifFilter") &&
  //     params[0].moduleName === "PolicyFee"
  //   ) {
  //     notificationFilter(params[0].moduleName, params[0].recordId).then(
  //       (result) => {
  //         setFilterStatus(true);
  //         setFilterPolicyFeeData(result);
  //       }
  //     );
  //   } else {
  //     localStorage.removeItem("NotifFilter");
  //     localStorage.removeItem("ModuleFilter");
  //   }
  // }, []);

  const handleSearchInputs = (fieldName, selectedValue) => {
    if (fieldName === "CarrierName") {
      searchInputsData.carrierName = selectedValue;
    }
    if (fieldName === "State") {
      searchInputsData.state = selectedValue;
    }
    if (fieldName === "FeeType") {
      searchInputsData.feeType = selectedValue;
    }
    if (fieldName === "FeeLevel") {
      searchInputsData.feeLevel = selectedValue;
    }
    if (fieldName === "PolicyTerm") {
      searchInputsData.policyTerm = selectedValue;
    }
    if (fieldName === "EffectiveDateFrom") {
      searchInputsData.effectiveDateFrom = selectedValue;
    }
    if (fieldName === "EffectiveDateTo") {
      searchInputsData.effectiveDateTo = selectedValue;
    }
    if (fieldName === "Refresh") {
      setResetStatus(true);
      searchInputsData.carrierName = "";
      searchInputsData.state = "";
      searchInputsData.feeType = "";
      searchInputsData.feeLevel = "";
      searchInputsData.policyTerm = "";
      searchInputsData.effectiveDateFrom = "";
      searchInputsData.effectiveDateTo = "";
    }
  };
  const filterPolicyFee = () => {
    if (!resetStatus) {
      setFilterStatus(true);
      searchMutation.mutate(searchInputsData);
    }
  };

  // Fetching PolicyFee Type
  useQuery("FeesTypes", getFeeType, {
    refetchOnWindowFocus: false,
    onSuccess: (res) => {
      let activeFeeType = res.filter((ft) => ft.isActive === true);
      setFeeTypeData(
        activeFeeType.map((data) => {
          return {
            label: data.feeTypeName,
            value: data.feeTypeName,
          };
        })
      );
    },
  });
  //Fetching Policy Terms

  //Fetching PolicyFee Details
  const { refetch, isLoading: getFeesLoading } = useQuery("Fees", getFees, {
    refetchOnWindowFocus: false,
    onSuccess: (res) => {
      setPolicyFeeData(
        res.map((data) => {
          return data;
        })
      );
    },
  });
  const { data: carriers, isLoading: carriersLoading } =
    useGetCarrierNameList();
  const carrierOptions = Array.from(
    new Map(
      carriers
        ?.filter((x) => x.isActive === true)
        ?.map((x) => [
          x.masterCarrierId,
          {
            label: x.carrierName,
            value: x.masterCarrierId,
          },
        ])
    ).values()
  );

  useQuery("States", getStates, {
    refetchOnWindowFocus: false,
    onSuccess: (res) => {
      setStates(
        res.map((data) => {
          return { label: data.state, value: data.stateId };
        })
      );
    },
  });
  useQuery("FeeLevel", getFeeLevel, {
    refetchOnWindowFocus: false,
    onSuccess: (res) => {
      let activeFeeLevel = res.filter((fl) => fl.isActive == true);
      setFeeLevelOptions(
        activeFeeLevel.map((data) => {
          return { label: data.feeLevelName, value: data.feeLevelId };
        })
      );
    },
  });

  const bulkDeleteMessage = (
    <div className="text-gray-500 font-normal">{`Are you sure you want to deactivate ${
      selectedRows?.length
    } policy ${selectedRows?.length > 1 ? "fees" : "fee"}?`}</div>
  );

  const singleDeleteMessage = (
    <div className="text-gray-500 font-normal">{`Are you sure you want to deactivate `}</div>
  );

  const deletePolicyFee = useMutation(
    (policyIds) => deletePolicyFees(policyIds),
    {
      onSuccess: (res) => {
        queryClient.invalidateQueries("Fees");
        toast.fire("Success", "Fees were Deactivated Successfully", "success");
        setSelectedRows([]);
        setClearSelectedRows(true);
      },
      onError: (error) => {
        toast.fire(
          "Bulk Deactivation of Fees Failed",
          "Server Error: Cannot Deactivate Fees",
          "error"
        );
        setSelectedRows([]);
        setClearSelectedRows(true);
      },
    }
  );

  const handleBulkDelete = () => {
    const ids = selectedRows.map((row) => row.commissionablePremiumId);
    deletePolicyFee.mutate(ids);
    setOpenModal(false);
    setIsBulkSelected(false);
    EditButton(false);
  };

  const handleDelete = () => {
    // deleteCarriersMutation.mutate(carrierToBeDeleted.id);
    // setProgressPending("loading");
    setOpenModal(false);
    setIsBulkSelected(false);
  };

  const handleSelectedRowsChange = useCallback((state) => {
    setSelectedRows(state.selectedRows);
    setIsBulkSelected((prev) => !prev);
  }, []);

  return (
    <Fragment>
      <div className="px-8 py-4 flex gap-2 items-center">
        <CreditCardIcon className="text-white bg-blue-500 rounded-md h-7 w-7 p-1" />
        <div className="flex flex-col leading tight">
          <h3 className="text-xs font-medium text-gray-500">
            Policy Fee Module
          </h3>
          <h1 className="mr-auto font-bold text-primary text-md uppercase">
            Policy Fee
          </h1>
        </div>
      </div>

      {addPolicyFee && (
        <AddPolicyFeeForm
          Cancel={() => setAddPolicyFee(false)}
          setAddPolicyFee={setAddPolicyFee}
          stateOptions={stateOptions}
          feeLevelOptions={feeLevelOptions}
          carrierOptions={carrierOptions}
          hideActionColumn={false}
          feeTypeData={feeTypeData}
          policyTermOptions={policyTermOptions}
        />
      )}
      {massUploadModal && (
        <MassUpload
          isOpen={massUploadModal}
          setMassUploadModal={setMassUploadModal}
        />
      )}

      {addPolicyFee &&
      userPermissions.includes(PERMISSIONS.permission_policyfee_view) ? (
        ""
      ) : userPermissions.includes(PERMISSIONS.permission_policyfee_view) ? (
        <div className="animate-fade-in-down flex justify-between  text-xs gap-x-4 items-center px-8 pb-2">
          <div>
            {" "}
            <button
              className="hover:scale-90 transition duration-500 flex justify-center items-center shadow-md px-3 py-1 h-7 text-xs 
                    gap-x-2 font-semibold text-primary border hover:bg-primary selected hover:text-white border-primary rounded-md"
              onClick={() => {
                setFilter(!filter);
              }}
            >
              <div>Filter By</div>
              <FunnelIcon className="h-3 w-3 focus:bg-primary" />
            </button>
          </div>
          <div className="gap-2 flex flex-row ">
            {userPermissions.includes(addPermission) ? (
              <AddButton
                buttonText="New Policy Fee"
                disabled={selectedRows.length > 0 ? true : ""}
                onClick={() => {
                  setAddPolicyFee(true);
                  setFilter(false);
                }}
              />
            ) : (
              ""
            )}
            {userPermissions.includes(addPermission) ? (
              <MassUploadButton
                onClickFunction={() => {
                  setMassUploadModal(true);
                }}
                className="hover:scale-90 transition duration-500 bg-tranparent border-quaternary shadow-md hover:bg-quaternary text-quaternary group relative flex justify-center items-center py-1 px-3 border text-xs font-medium rounded-full hover:text-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-quaternary focus:ring-opacity-70"
              >
                <ArrowUpCircleIcon className="h-4 w-4 mr-2" />
                <p className=""> Mass Upload</p>
              </MassUploadButton>
            ) : (
              ""
            )}

            {/* <div className="mr-1">
                {userPermissions.includes(downloadPremission) ? (
                  <DownloadButton
                    buttonValue="Download File"
                    disabled={selectedRows.length > 0 ? true : ""}
                    onClick={handleExportButton}
                  />
                ) : (
                  ""
                )}
              </div> */}
          </div>
        </div>
      ) : (
        ""
      )}

      <ConfirmBoxModal
        ModalTitle="Deactivate Policy Fee"
        qConfirmation={isBulkSelected ? bulkDeleteMessage : singleDeleteMessage}
        isOpen={openModal}
        onClose={() => setOpenModal(false)}
        onClickFunction={isBulkSelected ? handleBulkDelete : handleDelete}
      />
      <div className="flex pb-2 gap-2 px-8">
        {filter && (
          <div className="w-1/4 bg-white">
            <TableFilters
              carrierOptions={carrierOptions}
              stateOptions={stateOptions}
              feeLevelOptions={feeLevelOptions}
              policyTermOptions={policyTermOptions}
              handleSearchInputs={handleSearchInputs}
              filterPolicyFee={filterPolicyFee}
              setResetStatus={setResetStatus}
              setFilterStatus={setFilterStatus}
              feeTypeData={feeTypeData}
            />
          </div>
        )}
        <div className="w-full h-5/6">
          {!addPolicyFee ? (
            <div className="text-secondary pb-2 italic text-xs3">
              <div>
                <p className="self-center font-bold italic inline-block mr-1">
                  Note:{" "}
                </p>
                Tick the box to deactivate some data.
              </div>
            </div>
          ) : (
            ""
          )}
          <div className="bg-white box-shadow overflow-x-auto mb-4">
            {addPolicyFee ? (
              ""
            ) : userPermissions.includes(
                PERMISSIONS.permission_policyfee_view
              ) ? (
              <PolicyFeeTable
                policyFeeData={
                  policyFeeFilteredData.length > 0
                    ? policyFeeFilteredData
                    : filterStatus
                    ? filterPolicyFeeData
                    : policyFeeData
                }
                isLoading={getFeesLoading}
                selectableRows={true}
                stateOptions={stateOptions}
                carrierOptions={carrierOptions}
                feeLevelOptions={feeLevelOptions}
                selectedRows={selectedRows}
                handleBulkDelete={handleBulkDelete}
                setOpenModal={setOpenModal}
                setIsBulkSelected={setIsBulkSelected}
                handleSelectedRowsChange={handleSelectedRowsChange}
                refetch={refetch}
                clearSelectedRows={clearSelectedRows}
                feeTypeData={feeTypeData}
                policyTermOptions={policyTermOptions}
              />
            ) : (
              ""
            )}
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default PolicyFee;
